import { ChangeEvent, useState } from 'react'

import PlainCheckbox from 'app/common/ui-next/plain-checkbox'

import styles from './DishesTableProcessingLevel.module.scss'

export const DishesTableProcessingLevel = ({
  locked,
  value,
  onChange,
}: {
  locked?: boolean
  value: { ready: boolean; raw: boolean }
  onChange: (value: { ready: boolean; raw: boolean }) => Promise<void>
}) => {
  const [disabled, setDisabled] = useState(false)

  const handleChangeReady = async (event: ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.currentTarget
    setDisabled(true)
    await onChange(checked ? { ...value, ready: true } : { ...value, ready: false, raw: true })
    setDisabled(false)
  }

  const handleChangeRaw = async (event: ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.currentTarget
    setDisabled(true)
    await onChange(checked ? { ...value, raw: true } : { ...value, raw: false, ready: true })
    setDisabled(false)
  }

  return (
    <div className={styles.root}>
      <PlainCheckbox
        value="ready"
        label="Готовая продукция"
        checked={value.ready}
        onChange={handleChangeReady}
        disabled={locked || disabled}
      />
      <PlainCheckbox
        value="raw"
        label="Сырье"
        checked={value.raw}
        onChange={handleChangeRaw}
        disabled={locked || disabled}
      />
    </div>
  )
}
